import { render } from "./QuestionOptionInput.vue?vue&type=template&id=30d439c2&ts=true"
import script from "./QuestionOptionInput.vue?vue&type=script&lang=ts"
export * from "./QuestionOptionInput.vue?vue&type=script&lang=ts"

import "./QuestionOptionInput.vue?vue&type=style&index=0&id=30d439c2&lang=sass"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__